import React, { useState, useEffect } from "react";
import "../SummaryUpdated/summaryUpdated.css";
import { BsDot } from "react-icons/bs";
import axios from "../../../axios";
import { Link, NavLink } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import UnAuthAssessmentPopup from "../../../DcmDetails/Assesment/Pending/QuestionTypes/UnAuthAssessmentPopup";
import InstructionsPopup from "../../../DcmDetails/Assesment/Pending/QuestionTypes/InstructionsPopup";
import AssessmentNotAllowedPopup from "../../../DcmDetails/Assesment/Pending/QuestionTypes/AssessmentNotAllowedPopup";
import AllQuestions from "../../../DcmDetails/Assesment/Completed/QuestionCompleted/AllQuestions";
import { Player } from "video-react";
import { IP } from "./../../../internalServer"
import { iconData } from "../../../iconData";
import PdfViewer from "../../../HwManagement/PdfViewer/PdfViewer";
import { shortenParagraph } from "../../../utils/Engagement";

export default function SummaryUpdated({ assessmentId, CloseSummaryShowToday, data, open, setCloseSummaryPopup }) {
  /**
   * sets how to display day based events on the sj schedule day view component
   * @param {*} param0
   * @returns
   */
  const { state } = useLocation()
  const navigate = useNavigate()
  let StudentData = JSON.parse(localStorage.getItem("breathForStudent"));
  function formatDate(dateString) {
    if (!dateString) return null;
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    // Pad single digits with a leading zero if needed
    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;
    return `${formattedDay}/${formattedMonth}/${year}`;
  }
  function formatTime(dateString) {
    if (!dateString) return null;
    const date = new Date(dateString);
    const formattedTime = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    return formattedTime;
  }

  function format_time(time) {
    if (!time || typeof time !== "string" || time.length < 4) {
      return "00:00:00";
    }
    const [hours, minutes] = time.match(/.{1,2}/g) || ["00", "00"];
    return `${hours}:${minutes}:00`;
  }

  function formateDateStartTime(summary) {
    if (!summary?.lecture?.start_time) return null;
    let start_time1 = format_time(summary?.lecture?.start_time);
    const date1 = new Date(summary?.schedule_date);

    let formattedDate = date1.toDateString();
    formattedDate = formattedDate.concat(
      ` ${start_time1} GMT+0530 (India Standard Time)`
    );
    return formattedDate;
  }

  function formateDateEndTime(summary) {
    if (!summary?.lecture?.end_time) return null;
    let end_time1 = format_time(summary?.lecture?.end_time);
    const date1 = new Date(summary?.schedule_date);
    let formattedDate = date1.toDateString();
    formattedDate = formattedDate.concat(
      ` ${end_time1} GMT+0530 (India Standard Time)`
    );
    return formattedDate;
  }


  const [summary, setSummary] = useState({});
  const [errMsg, setErrMsg] = useState("Something went Wrong!");
  const [unAuthPopup, setUnAuthPopup] = useState(false);
  const [instructionsPopup, setInstructionsPopup] = useState(false);
  const [notAllowedPopup, setNotAllowedPopup] = useState(false);
  const [currentAssessmentId, setCurrentAssessmentId] = useState(null);
  const [completedAssQestion, setCompletedAssQestion] = useState(false)
  const [compAssId, setComAssId] = useState("")
  const [isClicked, setIsClicked] = useState(false);
  const [isError, setIsError] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
  });
  const [summaryData, setSummaryData] = useState([])
  useEffect(() => {
    const summaryCard = async () => {
      try {
        const supplementId = data?.SupplementId || state?.SupplementId;
        if (supplementId) {
          let response = await axios.get(
            `/summary/get/${supplementId}?studentId=${StudentData.id}`
            //`/summary/get/63e0a7ae3373bc5d8c9d6a7c?studentId=638dee5fc4d6787791bfa3b2`
          );
          if (response.data.data === null) {
            // open();
          } else {
            if (response) {
              setSummary(response?.data)
              setSummaryData(response?.data?.data)
            }
          }
        } else {
          CloseSummaryShowToday();
          setCloseSummaryPopup(false)
          open();
        }
      } catch (error) {
        console.log(error);
      }
    };
    summaryCard();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const isReadyToOpen = async (assessmentId) => {
    if (summary?.data?.assessment) {
      try {
        const reshw = await axios.get(`/assessment/studentStatus/assessmentId/${assessmentId}/studentId/${StudentData.id}`)
        // console.log("reshw", reshw)
        const status = reshw?.data?.data?.status
        switch (status) {
          case 'pending':
            try {
              let res = await axios.get(`/assessment/getForStudent/${assessmentId}`);
              let res2 = await axios.get(
                `/assessment/getStartedFlag/assessmentId/${assessmentId}/studentId/${StudentData.id}`
              );

              if (res && res2) {
                setCurrentAssessmentId(assessmentId);
                if (res2?.data?.data?.started_flag === false) {
                  setInstructionsPopup(true);
                } else {
                  setNotAllowedPopup(true);
                }
                // navigate(`/Assessment/pending/questions/${currentAssessmentId}`)
              }
              if (res) {
                return true;
              }
            } catch (error) {
              setErrMsg(error?.response?.data?.message);
              setUnAuthPopup(true);
              return false;
            }

            break;
          case 'review':
            navigate("/Assessment/review/questions", { state: { assessmentId: summary?.data?.assessment?.id } })
            break;
          case "completed":
            setCompletedAssQestion(true)
            setComAssId(summary?.data?.assessment?.id)
            //   navigate("/completedHomework", { state: { homeworkId: summary?.data?.homework?.id } })
            break;
          default:
            navigate("/Summary")
        }
      } catch (error) {
        console.log("error", error)
      }
    }

  };
  const homeworkHelperFunc = async (homeworkId) => {
    if (summary?.data?.homework) {
      try {
        const reshw = await axios.get(`/homework/studentStatus/homeworkId/${homeworkId}/studentId/${StudentData.id}`)
        const status = reshw?.data?.data?.status
        switch (status) {
          case 'pending':
            navigate("/publishedHomework", { state: { homeworkId: summary?.data?.homework?.id } })
            break;
          case 'review':
            navigate("/reviewHomework", { state: { homeworkId: summary?.data?.homework?.id } })
            break;
          case 'completed':
            navigate("/completedHomework", { state: { homeworkId: summary?.data?.homework?.id } })
            break;
          default:
            navigate("/Summary")
        }
      } catch (error) {
        console.log("error", error)
      }
    }
  }
  const preReadHelperFunc = async (preReadId) => {
    if (summary?.data?.pre_read) {
      try {
        const reshw = await axios.get(`/preRead/studentStatus/preReadId/${preReadId}/studentId/${StudentData.id}`)
        const status = reshw?.data?.data?.status
        switch (status) {
          case 'pending':
            navigate("/preReads/published", { state: { preReadId: summary?.data?.pre_read?.id } })
            break;
          case 'completed':
            navigate("/presRead/completed", { state: { preReadId: summary?.data?.pre_read?.id } })
            break;
          default:
            navigate("/Summary")
        }
      } catch (error) {
        console.log("error", error)
      }
    }
  }

  const acticityHelperFunc = async (activityId) => {
    if (summary?.data?.activity) {
      try {
        const reshw = await axios.get(`/activity/studentStatus/activityId/${activityId}/studentId/${StudentData.id}`)
        console.log("reshw", reshw)
        const status = reshw?.data?.data?.status
        console.log("status", status)
        switch (status) {
          case 'pending':
            navigate("/publishedActivity", { state: { activityId: summary?.data?.activity?.id } })
            break;
          case 'review':
            navigate("/reviewActivity", { state: { activityId: summary?.data?.activity?.id } })
            break;
          case 'completed':
            navigate("/completedActivity", { state: { activityId: summary?.data?.activity?.id } })
            break;
          default:
            navigate("/Summary")
        }
      } catch (error) {
        console.log("error", error)
      }
    }
  }


  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
    });
  };
  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };

  return (
    <div className="summary_container p-4">
      <div className="flex">
        <img
          onClick={() => {
            if (state?.from === 'summary') {
              navigate('/Summary')
            } else {
              setCloseSummaryPopup(false)
            }
          }}
          className="backArrow_summary"
          src="/DCM-img/BackArrowSummary.svg"
          alt=""
        ></img>
        <div className="summary_heading_dcm ">Today Summary</div>
      </div>
      <div className="summarySubContainer  mt-4">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-2">
            <div>
              <img src="/DCM-img/SubjectIconSci.png" alt=""></img>
            </div>
            <div>
              <div className="subheading_dcm"> {data?.name || summaryData?.lecture?.name || ''}</div>
              <span className="sumarySubjectDate">
                {data !== undefined
                  ? formatDate(data.StartTime)
                  : summaryData && formateDateStartTime(summaryData)
                    ? formatDate(formateDateStartTime(summaryData))
                    : null}
              </span>
              <span className="sumary_time">
                {" "}
                {data?.StartTime !== undefined ? formatTime(data?.StartTime) : formatTime(formateDateStartTime(summaryData))} - {data?.EndTime !== undefined ? formatTime(data?.EndTime) : formatTime(formateDateEndTime(summaryData))}
              </span>
            </div>
          </div>

          <div>
            <div>
              <span className="sumarySubjectDate">Subject :</span>&nbsp;
              <span className="subejctDetail">{data?.Subject || summaryData?.lecture?.subject?.name || ''}</span>
            </div>
            <div>
              <span className="sumarySubjectDate">Teacher :</span>&nbsp;
              <span className="subejctDetail">{data?.Teacher?.name || summaryData?.lecture?.teacher?.name || ''}</span>
            </div>
          </div>
        </div>

        <div className="col-12 row p-0 ">
          <div className="subContainer1 col-md-7 col-12 mt-2">
            <div className="Lesson_Description">Lecture Instruction</div>
            {summaryData?.lecInstruction ? (
              <div className="Default_text paragraphLengthIns">
                {summaryData?.lecInstruction}
              </div>
            ) : (
              <>
                <p className="Default_text">
                  {`Lecture Instruction not available`}
                </p>
              </>
            )}
            <div className="Lesson_Description">Lecture Summary</div>
            {summaryData?.description ? (
              <div className="Default_text paragraphLengthDesc"> {summaryData?.description}</div>
            ) : (
              <>
                <p className="Default_text">
                  {`Description not available`}
                </p>
              </>
            )}

            <div className="main_attach_box">
              <div className="">
                <div className="sharedText">
                  Shared Files
                </div>
                <div style={{ display: "flex", gap: "10px", padding: "0px 10px", overflowY: "scroll" }}>
                  {summaryData?.attachments?.length > 0 &&
                    summaryData?.attachments?.map(
                      (attachment, index) => (
                        <div key={index}>
                          {attachment.split(".").pop() !== "mp4" ? (
                            <>
                              {attachment.split(".").pop() === "jpg" ||
                                attachment.split(".").pop() === "jpeg" ||
                                attachment.split(".").pop() === "JPEG" ||
                                attachment.split(".").pop() === "JPG" ||
                                attachment.split(".").pop() === "PNG" ||
                                attachment.split(".").pop() === "png" ? (
                                <img
                                  style={{ cursor: "pointer" }}
                                  className="mt-3 imageWidthAndHeight"
                                  src={IP + attachment?.replace(/^\./, "")}
                                  alt="Attachment"
                                  onClick={() => {
                                    if (!isError) {
                                      handleClick(attachment);
                                    }
                                  }}
                                />
                              ) : (
                                <div
                                  key={index}
                                  onClick={(e) => {
                                    setPedingSubDetail({
                                      ...pedingSubDetail,
                                      pdfView: true,
                                      attachment: attachment,
                                    });
                                  }}
                                  className="mt-2"
                                >
                                  <div className="d-flex pdfContainer gap-2 p-2 ">
                                    <div className="d-flex align-items-center">
                                      <img
                                        className="extention_icon"
                                        src={`${iconData?.find(
                                          (i) =>
                                            i.extension ===
                                            attachment?.match(/\.([^.]+)$/)[1]
                                        )?.icon
                                          }`}
                                        alt=""
                                      />
                                    </div>
                                    <div className="w-100">
                                      <div className="pdfName">
                                        {attachment?.replace(/^[^_]*_/, "")}
                                      </div>
                                      <div className="pdfFileSize">12 KB</div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          ) : (
                            <div className="vidio_player mt-3" onClick={() => {
                              handleClick(attachment);
                            }}>
                              <div className="d-flex pdfContainer gap-2 p-2 ">
                                <div className="d-flex align-items-center">
                                  <img
                                    className="extention_icon"
                                    src={`${iconData?.find(
                                      (i) =>
                                        i.extension ===
                                        attachment?.match(/\.([^.]+)$/)[1]
                                    )?.icon
                                      }`}
                                    alt=""
                                  />
                                </div>
                                <div className="w-100">
                                  <div className="pdfName">
                                    {attachment?.replace(/^[^_]*_/, "")}
                                  </div>
                                  <div className="pdfFileSize">12 KB</div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )
                    )
                  }
                </div>

              </div>
              <div className="preread_attachPdf">
                {/* {attach &&
              attach.map((obj, index) => (
                <AttachmentLM
                  attach={obj}
                  id={index}
                  fileSize={attachmentSize[index]}
                />
              ))} */}
              </div>
            </div>
            {/* <div className="Relevant_links">Relevant links / references</div> */}

            {/* {summary?.data?.bbb_lecture_summary?.reference?.length > 0 ? (
              summary?.data?.bbb_lecture_summary?.reference?.map(
                (ref, index) => (
                  <div className="container_links_text">
                    <div key={index} className="col-md-8 p-0">
                      <div className="link_text1 d-flex">
                        <div>
                          <BsDot size={25} className="color" />
                        </div>
                        {ref}
                      </div>
                    </div>
                    <Link to={ref} className="view_summary">
                      View
                    </Link>
                  </div>
                )
              )
            ) : (
              <>
                <div className="d-flex polls_text1">
                  <BsDot size={25} className="color" />
                  <h6>Relevant links/references not available</h6>
                </div>
                <p className="color para">Please check after some time.</p>
              </>
            )} */}
            {/* <div className="summary_polls">Yours Polls</div> */}
            {/* {summary?.data?.bbb_lecture_summary?.polls?.length > 0 ? (
              summary?.data?.bbb_lecture_summary?.polls?.map((poll, index) => (
                <div>
                  <div className=" polls_text1 d-flex">
                    <div>
                      <BsDot size={25} className="color" />
                    </div>
                    <h6>Polls-{index + 1}</h6>
                  </div>
                  <div className="container_polls_text">
                    <p className="polls_text2 ml-2">{poll?.question}</p>
                    {poll?.correct_answer?.key &&
                      poll?.student_answer?.key === poll?.correct_answer?.key ? (
                      <p>
                        <img
                          className="mr-2"
                          src="/DCM-img/CorrectIcon.png"
                          alt="CorrectArrow"
                        ></img>
                        <span className="Correct_name">Correct</span>
                      </p>
                    ) : poll?.correct_answer?.key &&
                      poll?.student_answer?.key !==
                      poll?.correct_answer?.key ? (
                      <p>
                        <img
                          className="mr-2"
                          src="/DCM-img/WrongIcon.png"
                          alt="WrongIcon"
                        ></img>
                        <span className="Wrong_name">Wrong</span>
                      </p>
                    ) : (
                      <p>
                        <span className="PendingPolls">Pending</span>
                      </p>
                    )}
                  </div>

                  <div>
                    <div className="d-flex flex-wrap gap-2">
                      {poll?.options?.length > 0 &&
                        poll?.options?.map((option, index) => (
                          <div
                            key={index}
                            className={` ${option?.key === poll?.correct_answer?.key
                              ? "OptionSeprateCotainer "
                              : poll?.student_answer?.key !==
                                poll?.correct_answer?.key &&
                                poll?.correct_answer?.key === option?.key
                                ? "OptionSeprateCotainerWrong"
                                : poll?.student_answer?.key === option?.key
                                  ? "OptionSeprateCotainerNone"
                                  : "container_polls_checkbox"
                              } p-2 `}
                          >
                            <div className="  d-flex align-items-center">
                              <div
                                className={`${poll?.student_answer?.key !== option?.key &&
                                  "optionCheckbox"
                                  }`}
                              >
                                {option?.key === poll?.correct_answer?.key ? (
                                  <img
                                    src="/DCM-img/RightTickSummaryOption.png"
                                    alt=""
                                  />
                                ) : poll?.student_answer?.key !==
                                  poll?.correct_answer?.key &&
                                  poll?.correct_answer?.key === option?.key ? (
                                  <img
                                    src="/DCM-img/CrossTickSummaryOption.png"
                                    alt=""
                                  />
                                ) : (
                                  poll?.student_answer?.key === option?.key && (
                                    <img
                                      src="/DCM-img/TickOrange.svg"
                                      alt=""
                                    />
                                  )
                                )}
                              </div>
                              <span className="check_box_label">
                                {option?.key}
                              </span>
                            </div>
                            <div className="answer_persentage">
                              {option?.votes || 0}%
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <>
                <div className="d-flex polls_text1">
                  <BsDot size={25} className="color" />
                  <h6>Polls not available</h6>
                </div>
                <p className="color para">Please check after some time.</p>
              </>
            )} */}
          </div>
          <div className="col-md-1"></div>
          <div className=" subContainer2 col-md-4  col-12">
            <div className="subContainer2_heading">Your Homework</div>
            {summary?.data?.homework ? (
              <div>
                <div className=" polls_text1 d-flex">
                  <div>
                    <BsDot size={25} className="color" />
                  </div>
                  <h6>{summary?.data?.homework?.name}</h6>
                </div>
                <div className="container_links_text">

                  <p className="color para" style={{ fontSize: "14px" }}>
                    {
                      <Tooltip
                        title={summary?.data?.homework?.description || summaryData?.assessment?.description}
                        arrow
                        placement="bottom"
                        enterDelay={200}
                        leaveDelay={100}
                      >
                        <div>
                          {shortenParagraph(summary?.data?.homework?.description, 100) || shortenParagraph(summaryData?.assessment?.description, 100)}
                        </div>
                      </Tooltip>
                    }
                  </p>
                  <NavLink>
                    <p className="view_summary" onClick={async (e) => {
                      e.preventDefault();
                      await homeworkHelperFunc(summary?.data?.homework?.id)
                    }}>View</p>
                  </NavLink>
                </div>
              </div>
            ) : (
              <>
                <div className="d-flex polls_text1">
                  <BsDot size={25} className="color" />
                  <h6>Homework not available</h6>
                </div>
                <p className="color para" style={{ fontSize: "13px" }}>Please check after some time.</p>
              </>
            )}

            <div className="subContainer2_heading">Your Pre-read</div>
            {summary?.data?.pre_read ? (
              <div>
                <div className=" polls_text1 d-flex">
                  <div>
                    <BsDot size={25} className="color" />
                  </div>
                  <h6>{summary?.data?.pre_read?.name}</h6>
                </div>
                <div className="container_links_text">
                  <p className="color para" style={{ fontSize: "14px" }}>
                    {
                      <Tooltip
                        title={summary?.data?.pre_read?.description}
                        arrow
                        placement="bottom"
                        enterDelay={200}
                        leaveDelay={100}
                      >
                        <div>
                          {shortenParagraph(summary?.data?.pre_read?.description, 250)}
                        </div>
                      </Tooltip>
                    }
                  </p>
                  <NavLink state={{ preReadId: summary?.data?.pre_read?.id }}>
                    <p className="view_summary"
                      onClick={async (e) => {
                        e.preventDefault();
                        await preReadHelperFunc(summary?.data?.pre_read?.id)
                      }}>View</p>
                  </NavLink>
                </div>
              </div>
            ) : (
              <>
                <div className="d-flex polls_text1">
                  <BsDot size={25} className="color" />
                  <h6>Pre-read not available</h6>
                </div>
                <p className="color para" style={{ fontSize: "13px" }}>Please check after some time.</p>
              </>
            )}

            <div className="subContainer2_heading">Your Activity</div>
            {summary?.data?.activity ? (
              <div>
                <div className=" polls_text1 d-flex">
                  <div>
                    <BsDot size={25} className="color" />
                  </div>
                  <h6 className="mb-2">{summary?.data?.activity?.name}</h6>
                </div>
                <div className="container_links_text">
                  <p className="color para" style={{ fontSize: "14px" }}>
                    {
                      <Tooltip
                        title={summary?.data?.activity?.description}
                        arrow
                        placement="bottom"
                        enterDelay={200}
                        leaveDelay={100}
                      >
                        <div>
                          {shortenParagraph(summary?.data?.activity?.description, 250)}
                        </div>
                      </Tooltip>
                    }
                  </p>
                  <NavLink>
                    <p className="view_summary"
                      onClick={async (e) => {
                        e.preventDefault();
                        await acticityHelperFunc(summary?.data?.activity?.id)
                      }}
                    >View</p>
                  </NavLink>
                </div>
              </div>
            ) : (
              <>
                <div className="d-flex polls_text1">
                  <BsDot size={25} className="color" />
                  <h6>Activity not available</h6>
                </div>
                <p className="color para" style={{ fontSize: "13px" }}>Please check after some time.</p>
              </>
            )}

            <div className="subContainer2_heading">Your Assessment</div>
            {summary?.data?.assessment ? (
              <div>
                <div className=" polls_text1 d-flex">
                  <div>
                    <BsDot size={25} className="color" />
                  </div>
                  <h6>{summary?.data?.assessment?.name}</h6>
                </div>
                <div className="container_links_text">
                  <p className="color para" style={{ fontSize: "14px" }}>
                    {
                      <Tooltip
                        title={summary?.data?.assessment?.description}
                        arrow
                        placement="bottom"
                        enterDelay={200}
                        leaveDelay={100}
                      >
                        <div>
                          {shortenParagraph(summary?.data?.assessment?.description, 250)}
                        </div>
                      </Tooltip>
                    }
                  </p>
                  <NavLink>
                    <p className="view_summary"
                      onClick={async (e) => {
                        e.preventDefault();
                        await isReadyToOpen(summary?.data?.assessment?.id);
                      }}
                    >View</p>
                  </NavLink>
                </div>
              </div>
            ) : (
              <>
                <div className="d-flex polls_text1">
                  <BsDot size={25} className="color" />
                  <h6>Assessment not available</h6>
                </div>
                <p className="color para" style={{ fontSize: "13px" }}>Please check after some time.</p>
              </>
            )}

            <div className="subContainer2_heading">Lecture Video Recording</div>
            {summary?.data?.bbb_lecture_summary?.playback_url?.length > 0 ? (
              <div>
                <div className=" polls_text1 d-flex">
                  <div>
                    <BsDot size={25} className="color" />
                  </div>
                  <h6>Video recording available</h6>
                </div>
                {summary?.data?.bbb_lecture_summary?.playback_url?.map(
                  (url, index) => (
                    <div key={index} className="container_links_text ">
                      <p className="polls_text2 playbackUrl ellipsis-container">
                        {url}
                      </p>
                      <Link to={url} className="view_summary">
                        View
                      </Link>
                    </div>
                  )
                )}
              </div>
            ) : (
              <>
                <div className="d-flex polls_text1">
                  <BsDot size={25} className="color" />
                  <h6>Video not available</h6>
                </div>
                <p className="color para" style={{ fontSize: "13px" }}>Please check after some time.</p>
              </>
            )}
          </div>
        </div>
      </div>
      {
        unAuthPopup && <UnAuthAssessmentPopup
          setUnAuthPopup={setUnAuthPopup}
          errMsg={errMsg}
          closingWindowFlag={false}
        />
      }
      {
        instructionsPopup && <InstructionsPopup
          setInstructionsPopup={setInstructionsPopup}
          currentAssessmentId={currentAssessmentId}
        />
      }
      {
        notAllowedPopup && <AssessmentNotAllowedPopup
          setNotAllowedPopup={setNotAllowedPopup}
          currentAssessmentId={currentAssessmentId}
        />
      }
      {
        completedAssQestion &&
        <AllQuestions assessmentId={compAssId} FromSummaryUpdate={"FromSummaryUpdate"} />
      }
      {pedingSubDetail.pdfView && (
        <PdfViewer
          handleRemovePdfVivwer={handleRemovePdfVivwer}
          attachment={pedingSubDetail?.attachment}
        />
      )}
      {isClicked &&
        (responseAttach.split(".").pop() === "mp4" || responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source src={IP + responseAttach.replace(/^\./, "")} type="video/mp4" />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {
                !isError ? (
                  <>
                    <img
                      className="imgMain"
                      src={IP + responseAttach?.replace(/^\./, "")}
                      alt="Full-size"
                      onError={(e) => {
                        setIsError(true)
                      }}
                    />
                    <div>
                      <img
                        className="crossIconImgQue"
                        onClick={handleClick}
                        src="/images/cross.png"
                        alt="Up Arrow"
                      />
                    </div>
                  </>
                ) : (
                  <div className="fullSizeImg" style={{ display: "flex", flexDirection: "column" }}>
                    <img
                      onClick={() => {
                        setIsError(false)
                        handleClick()
                      }}
                      src="/images/cross.png"
                      alt="Up Arrow"
                      style={{ position: "absolute", top: "75px", right: "40%" }}
                    />
                    <img src="/images/no-photo1.png" alt="img" style={{ width: "25%" }} />
                    <p style={{ color: "red", fontSize: "20px", fontWeight: "500", marginRight: "35px" }}>Error!! failed to load the requested file!</p>
                  </div>
                )
              }
              {/* <img
                className="imgMain"
                src={IP + responseAttach?.replace(/^\./, "")}
                alt="Full-size"
              />
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div> */}
            </div>
          </div>
        ))}
    </div >
  );
}
